import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Products() {
  return <section id="productos" className="py-24 bg-white" data-id="element-143">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-144">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-145">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-brand-charcoal mb-4" data-id="element-146">
            Nuestras Guías Digitales
          </h2>
          <p className="text-lg text-brand-gray" data-id="element-147">
            Cada guía es un método completo, paso a paso, basado en ciencia.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto" data-id="element-148">
          {/* Card 1 */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-xl shadow-black/5 border border-gray-100 flex flex-col group hover:-translate-y-1 transition-transform duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-149">
            <div className="h-2 w-full bg-brand-salmon" data-id="element-150"></div>
            <div className="relative h-64 overflow-hidden" data-id="element-151">
              <img src="https://cdn.magicpatterns.com/uploads/nVHRRizLqYUzJgfosUobH1/Cenas_sin_Batallas_(2).png" alt="Familia latina disfrutando una cena juntos" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-152" />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wide text-brand-salmon shadow-sm" data-id="element-153">
                MÁS VENDIDO 🔥
              </div>
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-154">
              <h3 className="font-display text-2xl lg:text-3xl font-bold text-brand-charcoal mb-3" data-id="element-155">
                Cenas sin Batallas
              </h3>
              <p className="text-brand-gray mb-6 min-h-[3rem]" data-id="element-156">
                Transforma la hora de cenar en un momento de paz familiar
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-157">
                <li className="flex items-start gap-3" data-id="element-158">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-159" />
                  <span className="text-brand-charcoal text-sm" data-id="element-160">
                    Para niños de 2 a 10 años
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-161">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-162" />
                  <span className="text-brand-charcoal text-sm" data-id="element-163">
                    Resultados desde la primera cena
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-164">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-165" />
                  <span className="text-brand-charcoal text-sm" data-id="element-166">
                    Sin peleas ni negociaciones
                  </span>
                </li>
              </ul>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-167">
                <span className="font-display text-2xl font-bold text-brand-charcoal" data-id="element-168">
                  $9.99
                </span>
                <a href="https://cenassinbatallas.elcodigodelbienestar.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-brand-emerald text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-900 transition-colors" data-id="element-169">
                  Quiero esta guía &rarr;
                </a>
              </div>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-xl shadow-black/5 border border-gray-100 flex flex-col group hover:-translate-y-1 transition-transform duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-170">
            <div className="h-2 w-full bg-brand-mint" data-id="element-171"></div>
            <div className="relative h-64 overflow-hidden" data-id="element-172">
              <img src="https://cdn.magicpatterns.com/uploads/dUwPJLSXViMLoqUSJTSBom/Resetea_tu_Cortisol_en_21_Dias.png" alt="Mujer latina estirándose al aire libre con luz dorada" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-173" />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wide text-brand-emerald shadow-sm" data-id="element-174">
                NUEVO ✨
              </div>
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-175">
              <h3 className="font-display text-2xl lg:text-3xl font-bold text-brand-charcoal mb-3" data-id="element-176">
                Resetea tu Cortisol en 21 Días
              </h3>
              <p className="text-brand-gray mb-6 min-h-[3rem]" data-id="element-177">
                Recupera tu energía y transforma tu salud hormonal naturalmente
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-178">
                <li className="flex items-start gap-3" data-id="element-179">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-180" />
                  <span className="text-brand-charcoal text-sm" data-id="element-181">
                    Duermes profundo desde semana 1
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-182">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-183" />
                  <span className="text-brand-charcoal text-sm" data-id="element-184">
                    Energía natural sin café
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-185">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-186" />
                  <span className="text-brand-charcoal text-sm" data-id="element-187">
                    Grasa abdominal que se reduce
                  </span>
                </li>
              </ul>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-188">
                <span className="font-display text-2xl font-bold text-brand-charcoal" data-id="element-189">
                  $9.99
                </span>
                <a href="https://reseteatucortisol.elcodigodelbienestar.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-brand-emerald text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-900 transition-colors" data-id="element-190">
                  Quiero esta guía &rarr;
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div className="text-center mt-12" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-191">
          <p className="text-brand-gray italic" data-id="element-192">Más guías en camino... 🌿</p>
        </motion.div>
      </div>
    </section>;
}